import { render } from "./IqToolsDiagram.vue?vue&type=template&id=063dc252&scoped=true&lang=pug"
import script from "./IqToolsDiagram.vue?vue&type=script&lang=js"
export * from "./IqToolsDiagram.vue?vue&type=script&lang=js"

import "./IqToolsDiagram.vue?vue&type=style&index=0&id=063dc252&lang=scss"
import "./IqToolsDiagram.vue?vue&type=style&index=1&id=063dc252&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063dc252"]])

export default __exports__